<template>
  <el-dialog
    title="视频分组管理"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        label="分组名称"
        prop="groupName">
      </el-table-column>
      <el-table-column
        label="排序优先级"
        width="100"
        prop="sortValue">
        <template
          slot="header"
          slot-scope="{ column}">
          <span>{{ column.label }}</span>
          <el-tooltip
            effect="dark"
            content="数字越小，分组的位置越靠前。"
            placement="top-start">
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        label="关联视频数"
        prop="trainingVideoIds">
        <template slot-scope="{ row }">
          <el-popover

            trigger="click">
            <el-table
              border=""
              :data="row.trainingVideos">
              <el-table-column
                label="视频名称"
                min-width="140"
                prop="videoName"> </el-table-column>
              <el-table-column
                label="视频链接"
                min-width="360"
                prop="videoPlayUrl">
                <template slot-scope="scope">
                  <el-link
                    type="primary"
                    style="font-size: 12px"
                    :underline="false"
                    :href="scope.row.videoPlayUrl"
                    target="_blank"
                    rel="noopener noreferrer">{{ scope.row.videoPlayUrl }}</el-link>
                </template>
              </el-table-column>
            </el-table>
            <el-link
              slot="reference"
              style="font-size: 12px"
              :underline="false"
              type="primary">{{ row.trainingVideoIds.length }}个</el-link>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        fixed="right"
        width="185">
        <template slot-scope="{ row }">
          <el-button
            style="margin-right: 10px"
            type="danger"
            @click="setitem(row)">
            关联视频
          </el-button>
          <el-dropdown>
            <el-button type="primary">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
              <el-dropdown-item @click.native="updateitem(row)">编辑</el-dropdown-item>
              <el-dropdown-item @click.native="sortValue(row)">优先级设置</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button
            type="danger"
            @click="deleteitem(row)">
            删除
          </el-button>
          <el-button
            type="info"
            @click="updateitem(row)">
            编辑
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button
        type="primary"
        @click="additem">新 增</el-button>
      <el-button @click="toggleModal(false)">关 闭</el-button>
      <edit-group-modal
        ref="group"
        :callback="
          () => {
            fetchList();
          }
        " />
      <group-video-modal
        ref="groupVideo"
        :callback="
          () => {
            fetchList();
          }
        " />
      <sort-group-value-modal
        ref="sort"
        :callback="
          () => {
            fetchList();
          }
        " />
    </div>
  </el-dialog>
</template>
<script>
import EditGroupModal from './edit-group-modal.vue'
import GroupVideoModal from './group-video-modal.vue'
import SortGroupValueModal from './sort-group-value-modal.vue'

export default {
  name: 'GroupMgrModal',
  components: { EditGroupModal, GroupVideoModal, SortGroupValueModal },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 1000
      }
    }
  },
  methods: {
    sortValue(row) {
      console.log(row)
      this.$refs.sort.update({
        groupId: row.groupId,
        groupName: row.groupName,
        sortValue: row.sortValue
      })
    },
    setitem(row) {
      const { groupId, groupName, trainingVideoIds } = row
      this.$refs.groupVideo.update({
        groupId, groupName, trainingVideoIds
      })
    },
    additem() {
      this.$refs.group.add()
    },
    updateitem(row) {
      const { groupId, groupName } = row
      this.$refs.group.update({
        groupId, groupName
      })
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/gettrainingvideogroups', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    deleteitem(row) {
      this.$confirm('此操作将永久删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletetrainingvideogroup', {
          payload: {
            groupId: row.groupId
          },
          success: () => {
            this.loading = false
            this.fetchList()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
